import $$ from 'cmn-utils'

const baseUrl = "/api/sys/product/part/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
}